export default "__VITE_ASSET__5057a6d0__"